import React from 'react';

import { Row, Col, AutoComplete, Typography } from 'antd';

const { Title, Text } = Typography;

export default function (props) {
	const { zones, zone, setLocation, selectLocation } = props.locationProps;

	const options = zones.map((item) => ({
		value: item.formatted_address,
		label: item.formatted_address,
		location: item,
	}));

	return (
		<div>
			<Row>
				<Col xs={24} md={12}>
					<Title level={3} style={{ marginBottom: 4 }}>User Details</Title>
					<Text type="secondary">What's your primary recruiting city, state?</Text>
				</Col>
			</Row>
			<Row style={{ marginTop: 16 }}>
				<Col xs={24} md={8}>
					<AutoComplete
						style={{ width: '100%' }}
						value={zone}
						options={options}
						placeholder="Location"
						onChange={(val) => setLocation(val, true)}
						onSelect={(val, option) => {
							setLocation(option.location.formatted_address);
							selectLocation(option.location);
						}}
					/>
				</Col>
			</Row>
		</div>
	);
}
